import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import posthog from "posthog-js";
import { StoreContext } from "./store/Store";
import { useParams } from "react-router";

export default function PostHogPageView() {
  let location = useLocation();
  const { dashboardPublicToken, eventId } = useParams() as any;
  const [state] = useContext(StoreContext);

  // Track pageviews
  useEffect(() => {
    if (!posthog || dashboardPublicToken) return;
    const eid = eventId ?? state.selectedEvent?.id;
    posthog.capture("$pageview", {
      path: location.pathname,
      search: location.search,
      eventId: eid ? `${eid}` : '',
    });
  }, [location]);

  useEffect(() => {
    if (!posthog) return;
    if (state.currentUser?.id) {
      posthog.identify(state.currentUser.id.toString());
      posthog.people.set({
        name: state.currentUser.fullName,
        email: state.currentUser.email,
        is_internal: state.currentUser.email
          ?.toLowerCase()
          .endsWith("@fielddrive.com"),
      });
    }
  }, [state.currentUser?.id]);

  return null;
}
